import { IApiError } from '@/models/apiError.model';
import { AdminSignInActions } from '@/models/auth.model';

export const AUTH_SLICE_NAME = 'auth';

export interface AuthState {
  isAuthorized: boolean | null;
  isLoading: boolean;
  currentAction: AdminSignInActions;
  authSessionId: string | null;
  setupMfaQrCode: string | null;
  setupMfaSecretCode: string | null;
  error: IApiError | null;
}

export const initialState: AuthState = {
  isAuthorized: null,
  currentAction: AdminSignInActions.SIGN_IN,
  authSessionId: null,
  setupMfaQrCode: null,
  setupMfaSecretCode: null,
  isLoading: false,
  error: null,
};
